module.exports = new __parcel__URL__("upward-chart.ae20e27d.png").toString();